import { glossaryListStandard } from 'humanity/components/glossaryList';

export const retirementGlossaryStandard = {
  sections: [
    {
      __typename: 'SimpleMasthead',
      paragraph: {
        json: {
          nodeType: 'document',
          data: {},
          content: [
            {
              nodeType: 'paragraph',
              data: {},
              content: [
                {
                  nodeType: 'text',
                  value: 'Description and stuff',
                  marks: [],
                  data: {},
                },
              ],
            },
          ],
        },
      },
      disclosures: null,
      alignment: 'center',
      variant: 'brightBlue10',
      heading: 'Retirement Glossary',
      headingHighlight: null,
      cta: null,
    },
  ],
  glossaryList: glossaryListStandard.list,
};
